import { render, staticRenderFns } from "./recom.vue?vue&type=template&id=52c000df&scoped=true"
import script from "./recom.vue?vue&type=script&lang=js"
export * from "./recom.vue?vue&type=script&lang=js"
import style0 from "./recom.vue?vue&type=style&index=0&id=52c000df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c000df",
  null
  
)

export default component.exports